import {Code, Table, Text} from "@mantine/core";
import {DriftFinding} from "../types.ts";
import {ActionBadge} from "./Badges.tsx";

// FNP-585: the per-account drift detail for a single sweep run. Findings are bounded
// (the sweep's REPAIR_CAP), so a plain table is enough — no pagination. Shows the
// before/after customerId so an operator can see exactly what drifted and what the
// sweep did about it.
export const FindingsTable = ({findings}: { findings: DriftFinding[] }) => {
    const rows = findings.map((f, idx) => (
        <Table.Tr key={`${f.accountId}-${idx}`}>
            <Table.Td><Code>{f.accountId}</Code></Table.Td>
            <Table.Td>{f.sourceCustomerId ? <Code>{f.sourceCustomerId}</Code> : <Text c={'dimmed'} size={'sm'}>—</Text>}</Table.Td>
            <Table.Td>{f.projectionCustomerId ? <Code>{f.projectionCustomerId}</Code> : <Text c={'dimmed'} size={'sm'}>—</Text>}</Table.Td>
            <Table.Td><ActionBadge action={f.action}/></Table.Td>
            <Table.Td>{f.sourceVersion ? <Text size={'sm'}>{f.sourceVersion}</Text> : <Text c={'dimmed'} size={'sm'}>—</Text>}</Table.Td>
        </Table.Tr>
    ));

    return (
        <Table withTableBorder withColumnBorders striped highlightOnHover>
            <Table.Thead>
                <Table.Tr>
                    <Table.Th>Account ID</Table.Th>
                    <Table.Th>Source Customer ID</Table.Th>
                    <Table.Th>Projection Customer ID</Table.Th>
                    <Table.Th>Action</Table.Th>
                    <Table.Th>Source Version</Table.Th>
                </Table.Tr>
            </Table.Thead>
            <Table.Tbody>{rows}</Table.Tbody>
        </Table>
    );
};
